import { cn } from "@/common/helpers/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { HISTORY_COLUMNS } from "./vehicle-valuation-history-columns";

interface VehicleValuationHistorySkeletonProps {
  rowCount: number;
}

export function VehicleValuationHistorySkeleton({ rowCount }: VehicleValuationHistorySkeletonProps) {
  return (
    <Table>
      <TableBody>
        {Array.from({ length: rowCount }, (_, i) => (
          <TableRow key={i} className="border-0 hover:bg-transparent">
            {HISTORY_COLUMNS.map((col) => (
              <TableCell key={col.headerKey} className={cn("py-1", col.hiddenOnMobile && "hidden sm:table-cell")}>
                <Skeleton className={cn("h-4", col.skeletonWidth)} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
